module.exports = __webpack_public_path__ + "static/img/1672_phase_function_Paper_PointsHejduk_Prediction.96a8996.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1672_phase_function_Paper_PointsHejduk_Prediction.png
// module id = KMH2
// module chunks = 0